import React from "react";
import { Link } from "react-router-dom";
import "../Styles/wedding-services-section.css";

export default function BusinessNetworkComingSoon() {
  return (
    <main className="business-coming-soon-page">
      <section className="wedding-services-container">
        <div className="wedding-services-card business-coming-soon-card">
          <h1 className="wedding-services-title">Business Network</h1>
          <p className="wedding-services-description business-coming-soon-message">
            This feature is coming soon.
          </p>
          <Link to="/home" className="wedding-services-link">
            Back to home ❯
          </Link>
        </div>
      </section>
    </main>
  );
}
